// The row of photos moves by itself where it does not fit (Sole's review of 19-10-2026): one photo every few
// seconds, back to the first after the last. It never moves for a visitor who asked for less motion, off screen or
// in a hidden tab, and the first touch, wheel or key on the row hands it to the visitor for good. The button pauses
// and resumes it, as anything that moves on its own for more than five seconds must allow (WCAG 2.2.2).
if (!customElements.get('photo-strip-autoplay')) {
  customElements.define(
    'photo-strip-autoplay',
    class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.photo-strip__scroller');
        this.button = this.querySelector('.photo-strip__toggle');
        if (!this.scroller || !this.button) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.interval = Number(this.dataset.interval) || 4000;
        this.paused = false;
        this.stopped = false;
        this.visible = false;
        this.button.addEventListener('click', () => this.setPaused(!this.paused));
        for (const type of ['pointerdown', 'wheel', 'keydown']) {
          this.scroller.addEventListener(type, () => this.stop(), { passive: true });
        }
        new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.update();
        }, { threshold: 0.5 }).observe(this);
        new ResizeObserver(() => this.update()).observe(this.scroller);
        document.addEventListener('visibilitychange', () => this.update());
      }

      overflows() {
        return this.scroller.scrollWidth - this.scroller.clientWidth > 1;
      }

      update() {
        const moving = !this.stopped && this.overflows();
        this.button.hidden = !moving;
        clearInterval(this.timer);
        if (moving && !this.paused && this.visible && !document.hidden) {
          this.timer = setInterval(() => this.next(), this.interval);
        }
      }

      next() {
        const item = this.scroller.querySelector('.photo-strip__item');
        const gap = parseFloat(getComputedStyle(item.parentElement).columnGap) || 0;
        const atEnd = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 2;
        this.scroller.scrollTo({
          left: atEnd ? 0 : this.scroller.scrollLeft + item.getBoundingClientRect().width + gap,
          behavior: 'smooth',
        });
      }

      setPaused(paused) {
        this.paused = paused;
        this.button.setAttribute('aria-label', paused ? 'Play the photos' : 'Pause the photos');
        this.button.classList.toggle('is-paused', paused);
        this.update();
      }

      stop() {
        this.stopped = true;
        this.update();
      }
    }
  );
}
